/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CBPopDetailsUpdateSpec { 
    /**
     * CB PoP ID
     */
    cb_pop_id: string;
    /**
     * CB PoP description
     */
    description?: string;
    /**
     * CB PoP internal description
     */
    internal_description?: string;
    /**
     * CB PoP Service Definition ID
     */
    service_definition_id?: string;
    /**
     * CB PoP Service Instance ID
     */
    service_instance_id?: string;
    /**
     * CB PoP url
     */
    url?: string;
}

